"use strict";

import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/effect-fade';
/* General + Third-Party */
import jQuery from 'jquery';
import { lazyload } from './globals/lazyload';
import Alpine from 'alpinejs';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Access Apline function to the window object
window.Alpine = Alpine
window.Swiper = Swiper;
window.Fancybox = Fancybox;

/* Layout-Parts */
import { navigationSubNav } from './layout/navigation';

/* Blocks */
import { teaserSliderInit } from '../../blocks/teaser-list/script';
import { playVideo } from '../../blocks/text-media/script';
import { sliderInit } from '../../blocks/slider/script';
import { textMediaSliderInit } from '../../blocks/text-media/script';
import { testimonialsInit } from '../../blocks/testimonials/script';
import { gallerySliderInit, galleryFancyboxInit } from '../../blocks/gallery/script';


jQuery(document).ready(_ => {
  // General + Third-Party
  Alpine.start();
  lazyload();

  //Layout-Parts
  navigationSubNav();


  //Blocks
  teaserSliderInit();
  playVideo();
  sliderInit();
  textMediaSliderInit();
  testimonialsInit();
  gallerySliderInit();
  galleryFancyboxInit();
});
